import {
  actions,
  getAllAuthorsAsync,
  getAuthorByIdAsync,
  getAuthorsAsDataTableAsync,
  getAuthorsLookUpsAsync,
  getContentEntityAuthorsAsync,
  editAuthorAsync,
  createNewAuthorAsync,
  deleteAuthorAsync,
  assignAuthortoContentAsync,
  unAssignAuthortoContentAsync,
  addAuthorByIdForHistoryAsync,
  getAuthorsToBeExportedAsync,
  getAuthorByIdMultilingualAsync,
  createAuthorMultilingualAsync,
  editAuthorMultilingualAsync,
} from './slices';

export const AuthorsActions = {
  ...actions,
  getAllAuthorsAsync,
  getAuthorByIdAsync,
  getAuthorsAsDataTableAsync,
  getAuthorsLookUpsAsync,
  getContentEntityAuthorsAsync,
  editAuthorAsync,
  createNewAuthorAsync,
  deleteAuthorAsync,
  assignAuthortoContentAsync,
  unAssignAuthortoContentAsync,
  addAuthorByIdForHistoryAsync,
  getAuthorsToBeExportedAsync,
  getAuthorByIdMultilingualAsync,
  createAuthorMultilingualAsync,
  editAuthorMultilingualAsync,
};

export * from './thunkHandlers';
